<app-header></app-header>
<app-banner></app-banner>

<div class="container contact-us">
  <div class="row">
    <div class="col-lg-4">
      <div class="d-flex justify-content-left">
        <p class="page-header mt-3">Contact Us</p>
      </div>
      
      <div class="d-flex justify-content-left mb-3">
        <p>Let us know how we can help</p>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-12">
          <mat-card class="contact-us-card mb-4" >
            <div class="icon-container" style="margin-top: 1rem">
              <img src="/assets/briefcase.png" alt="" />
            </div>
            <mat-card-content>
              <h5>Public Employment Office (PESO)</h5>
              <div class="contianer">
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Telephone:</strong></p>
                    <ul style="list-style: none; padding: 0px; margin-left: 1rem">
                      <li style="font-size: 14px">(074) 442-4299</li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Email:</strong></p>
                    <ul class="ul-list">
                      <li style="font-size: 14px">peso_baguio@yahoo.com</li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Address:</strong></p>
                    <ul class="ul-list">
                      <li style="font-size: 14px">
                        City Hall Loop 2600 Baguio City, Philippines
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-lg-12">
          <mat-card class="contact-us-card mb-4">
            <div class="icon-container" style="margin-top: 1rem">
              <img src="/assets/heartbeat.png" alt="" />
            </div>
            <mat-card-content>
              <h5>City Health Services Office (CHSO)</h5>
              <div class="contianer">
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Telephone:</strong></p>
                    <ul style="list-style: none; padding: 0px; margin-left: 1rem">
                      <li style="font-size: 14px">(074) 655-2757</li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Email:</strong></p>
                    <ul class="ul-list">
                      <li style="font-size: 14px">hso.baguio@gmail.com</li>
                      <li style="font-size: 14px">healthservicesoffice@yahoo.com</li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Address:</strong></p>
                    <ul class="ul-list">
                      <li style="font-size: 14px">
                        T. Alonzo Street, Baguio, 2600 Benguet, Philippines
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-lg-12">
          <mat-card class="contact-us-card">
            <div class="icon-container" style="margin-top: 1rem">
              <img src="/assets/police-station.png" alt="" />
            </div>
            <mat-card-content>
              <h5>Baguio City Police Office (BCPO)</h5>
              <div class="contianer">
                <div class="row mt-3">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Telephone:</strong></p>
                    <ul style="list-style: none; padding: 0px; margin-left: 1rem">
                      <li style="font-size: 14px">(074) 661-1471</li>
                      <li style="font-size: 14px">0998-598-7739</li>
                      <li style="font-size: 14px">0917-575-8993</li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Email:</strong></p>
                    <ul class="ul-list">
                      <li style="font-size: 14px">piobcpo@yahoo.com</li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" class="item-list">
                    <p><strong>Address:</strong></p>
                    <ul class="ul-list">
                      <li style="font-size: 14px">
                        Abanao Street - Kayang extension, Baguio City, Philippines
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
